import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { FormValidatorService } from '../../../../shared/services/form-validator.service';
import { Validators } from '../../../../shared/validators';
import { CustomValidators } from '../../../../shared/custom-validators';
import { LanguageService } from '../../../../shared/services/language.service';
import { AddOrganizationService } from 'src/app/shared/services/add-organization';

@Component({
  selector: 'app-add-organization.component',
  templateUrl: './add-organization.component.html',
  styleUrls: ['./add-organization.component.scss'],
})
export class AddOrganizationComponent implements OnInit, AfterViewInit {
  newBusinessForm!: FormGroup;
  error: boolean = false;
  errorMsg: string = '';
  notOnlyNumPattern = /(?!^\d+$)^.+$/g;
  roles: { id: number; name: string }[] = [];
  formValidator = new FormValidatorService();
  validationError!: [
    {
      field: string;
      message: string;
      validation: string;
    },
  ];

  constructor(
    private creatOrganizationService: AddOrganizationService,
    private router: Router,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) {}

  async ngOnInit() {
    if (localStorage.getItem('language') === 'ar') {
      this.translate.use('ar');
    } else {
      this.translate.use('en');
    }
    this.languageService.languageUpdated.subscribe((lang) => {
      this.translate.use(lang);
    });
    this.initForm();
  }

  ngAfterViewInit() {
    this.translateValidationMessages();
    this.translate.onLangChange.subscribe(() => {
      this.translateValidationMessages();
    });
  }

  translateValidationMessages() {
    this.translate.get('FormValidation').subscribe(() => {
      this.formValidator.validationMessages = {
        newBusinessName: {
          required: this.translate.instant('FormValidation.Empty', {
            field: 'Business name',
            fieldAr: 'الإسم التجاري',
          }),
          customPattern: this.translate.instant('FormValidation.TextOnly', {
            field: 'Business name',
            fieldAr: 'الإسم التجاري',
          }),
          minlength: this.translate.instant('FormValidation.MinLength', {
            field: 'Business name',
            fieldAr: 'الإسم التجاري',
            value: 2,
          }),
        },
      };
    });
  }

  async initForm() {
    this.newBusinessForm = this.formValidator.createForm([
      {
        fieldName: 'newBusinessName',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: '',
          },
          {
            validatorFn: Validators.minLength(2),
            message: '',
          },
          {
            validatorFn: CustomValidators.customPattern(this.notOnlyNumPattern),
            message: '',
          },
        ],
      },
    ]);
  }

  async onSubmit() {
    try {
      this.error = false;
      this.creatOrganizationService.setParams(this.newBusinessForm.value);
      await this.creatOrganizationService.make();
      this.router.navigate(['/seller/organization']);
    } catch (errors) {
      if (errors.faultyRequest)  {
        this.error = true;
        this.errorMsg = errors.faultyRequest.error.message;
      }
      this.validationError = errors.validationErrors.error;
      for (const e of this.validationError) {
        this.formValidator.addError(e.field, 'invalid', e.message);
        this.newBusinessForm.controls[e.field].setErrors({
          invalid: e.message,
        });
        this.formValidator.ShowErrors();
      }
    }
  }
}
